const products = [
  {
    path: '/gifts',
    name: 'gifts',
    component: () => import('@/views/products/gifts/index.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_products',
      resource: 'all',
    },
  },
  {
    path: '/gifts/:id',
    name: 'gifts-id',
    component: () => import('@/views/products/gifts/index.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_products',
      resource: 'all',
    },
  },
  {
    path: '/gifts/create_gifts',
    name: 'create-gifts',
    component: () => import('@/views/products/gifts/add_edit.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_create_digital_product',
      resource: 'all',
    },
  },
  {
    path: '/gifts/edit_gifts/:id',
    name: 'edit-gifts',
    component: () => import('@/views/products/gifts/add_edit.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_edit_digital_product',
      resource: 'all',
    },
  },
  {
    path: '/gifts/sub/:id',
    name: 'add-sub-gifts',
    component: () => import('@/views/products/gifts/repository/index.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_add_code',
      resource: 'all',
    },
  },
]

export default products
